import React, { useEffect, useState } from "react";
import api from "../../lib/api";

let cache = null;
const listeners = new Set();
export const loadBlogCovers = (force = false) => {
  if (!cache || force) cache = api.get("/blog/covers").then((r) => r.data).catch(() => ({}));
  cache.then((d) => listeners.forEach((fn) => fn(d)));
  return cache;
};
const useCovers = () => {
  const [d, setD] = useState({});
  useEffect(() => { listeners.add(setD); loadBlogCovers(); return () => listeners.delete(setD); }, []);
  return d;
};

const UNIT = /(\d[\d\s.,]*\s?(?:€|%|ans?\b|mois\b|jours?\b|m²|mois))/i;
const YEAR = /\b((?:19|20)\d{2})\b/;
// Premier chiffre marquant (avec unité, sinon une année) du titre, puis du résumé, puis du contenu.
export const autoFigure = (post) => {
  const parts = [post.title, post.excerpt, JSON.stringify(post.sections || []).replace(/"[a-zA-Z]+":/g, " ")];
  for (const re of [UNIT, YEAR]) {
    for (const t of parts) {
      const m = (t || "").match(re);
      if (m) return m[1].replace(/\s+/g, " ").replace(/[.,]$/, "").trim();
    }
  }
  return "360°";
};

// Couverture de marque : fond ivoire ou graphite (alterné), chiffre clé en laiton, titre en Fraunces.
export const BlogCover = ({ post, index = 0, size = "md", className = "" }) => {
  const covers = useCovers();
  const o = covers[post.slug] || {};
  const dark = o.theme ? o.theme === "graphite" : index % 2 === 0;
  const fig = o.figure || autoFigure(post);
  const big = size === "lg";
  const sm = size === "sm";
  return (
    <div className={`relative w-full h-full flex flex-col justify-between ${big ? "p-8 lg:p-12" : sm ? "p-4" : "p-6"} ${dark ? "bg-brand-graphite" : "bg-brand-ivoire"} ${className}`} data-testid={`blog-cover-${post.slug}`}>
      <img src={`/brand/360immoinvest-logo-horizontal-${dark ? "sombre" : "clair"}.png`} alt="" className={big ? "h-6 w-auto self-start" : sm ? "h-3 w-auto self-start" : "h-4 w-auto self-start"} />
      <p className={`font-display leading-[0.9] tracking-[-0.02em] whitespace-nowrap ${dark ? "text-brand-laiton" : "text-brand-accentText"} ${big ? "text-6xl lg:text-8xl" : sm ? "text-3xl" : "text-5xl"}`} data-testid={`blog-cover-figure-${post.slug}`}>{fig}</p>
      <p className={`font-display font-medium ${dark ? "text-brand-ivoire" : "text-brand-graphite"} ${big ? "text-2xl lg:text-3xl max-w-xl" : sm ? "text-sm" : "text-lg"} leading-tight line-clamp-2`}>{post.category ? post.category.toLowerCase() : ""}</p>
    </div>
  );
};
